/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_TitleInputs */

const en_wc_faq_title = /** @type {(inputs: Wc_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraftApp questions, answered`)
};

/**
* | output |
* | --- |
* | "WordCraftApp questions, answered" |
*
* @param {Wc_Faq_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_title = /** @type {((inputs?: Wc_Faq_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_title(inputs)
});
export { wc_faq_title as "wc.faq.title" }